import { InlineButton } from '@platform/ui'
import { createRoot } from 'react-dom/client'
import i18n from '@/plugins/i18n'
import { fullScreenButtonClickHandler } from './fullScreenButtonClickHandler'
import { wrapTableContainer } from './wrapTableContainer'

export const addFullScreenButtons = (element: HTMLDivElement, lockScroll: () => void, unlockScroll: () => void) => {
  if (!element) {
    return
  }

  element.querySelectorAll<HTMLDivElement>('.table-container').forEach((tableContainer) => {
    let tableWrapper = tableContainer.parentElement as HTMLDivElement

    if (!tableWrapper?.classList?.contains?.('table-wrapper')) {
      tableWrapper = wrapTableContainer(tableContainer)
    }

    let tableMaximizeButtonDiv = tableWrapper.querySelector('.table-maximize-button')!

    if (tableMaximizeButtonDiv) {
      tableMaximizeButtonDiv.innerHTML = ''
    }

    if (!tableMaximizeButtonDiv) {
      tableMaximizeButtonDiv = document.createElement('div')
      tableMaximizeButtonDiv.classList.add('table-maximize-button')
      tableWrapper.prepend(tableMaximizeButtonDiv)
    }

    const root = createRoot(tableMaximizeButtonDiv)

    root.render(
      <>
        <div className="full-screen-enter">
          <InlineButton
            onClick={() => fullScreenButtonClickHandler(tableWrapper, lockScroll, unlockScroll)}
            iconBeforeText="FullscreenMediumStroke"
            size="small"
            data-full-screen-click-handler-attached="1"
            text={i18n.t('table.viewFullScreen')}
          />
        </div>
        <div className="full-screen-exit">
          <InlineButton
            onClick={() => fullScreenButtonClickHandler(tableWrapper, lockScroll, unlockScroll)}
            iconBeforeText="FullscreenExitMediumStroke"
            size="small"
            data-full-screen-click-handler-attached="1"
            text={i18n.t('table.exitFullScreen')}
          />
        </div>
      </>,
    )
  })
}
